import React from 'react';
import {Route, useRouteMatch, withRouter, Switch} from "react-router-dom";

// My Games Pages
import GamesList from "./GamesList";
import GamePage from "./GamePage";
import ParticipatingClubsPage from "./ParticipatingClubsPage";
import PlayerContacts from "../PlayerContacts";

import "./styles.css";

const MyGames = () => {
   let match = useRouteMatch();

   return <Switch>
      <Route
         exact
         path={`${match.path}/game/:matchId/scheduled`}
         render={() => (
            <GamePage scheduled/>
         )}
      />

      <Route
         exact
         path={`${match.path}/game/:matchId/played`}
         render={() => (
            <GamePage played/>
         )}
      />

      <Route exact path={`${match.path}/game/:matchId`} component={GamePage}/>

      <Route exact path={`${match.path}/game/:matchId/participating_clubs`} component={ParticipatingClubsPage}/>

      <Route exact path={`${match.path}/game/:matchId/contacts`} component={PlayerContacts}/>

      <Route exact path={`${match.path}`} component={GamesList}/>
   </Switch>;
}

export default withRouter(MyGames);
